import { render, staticRenderFns } from "./BdCrm.vue?vue&type=template&id=d81cd944&scoped=true&"
import script from "./BdCrm.vue?vue&type=script&lang=js&"
export * from "./BdCrm.vue?vue&type=script&lang=js&"
import style0 from "./BdCrm.vue?vue&type=style&index=0&id=d81cd944&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d81cd944",
  null
  
)

export default component.exports